import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
export const CheckboxCell = _ref => {
  let {
    value,
    onChange,
    disabled = false,
    fieldName = '',
    body = {}
  } = _ref;
  const [internalValue, setInternalValue] = useState(value);
  useEffect(() => {
    setInternalValue(value);
  }, [value]);
  return /*#__PURE__*/React.createElement(Form.Check, {
    checked: internalValue,
    onChange: e => {
      onChange(fieldName, !internalValue, body);
      setInternalValue(!internalValue);
    },
    disabled: disabled,
    name: fieldName,
    size: "sm"
  });
};